import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';
import * as XLSX from 'xlsx-js-style';
// import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import converCsvtoJSON from 'csvtojson';
import { isNaN } from 'lodash';
import * as AppConstants from '../AppConstants';
import ExportIcon from '../../assets/images/Icon-Component-Export.svg';

import printDoc from './PrintDocComponent';
import { updateActionBit } from '../../Modules/Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import { dispatchGridLevelActions } from '../../Modules/Tasks/AllocatePayments/store/Actions';
import { dispatchPQASGridLevelActions } from '../../Modules/Tasks/AllocatePayments/PQASTab/store/Actions';
import { pqasPageChanges } from '../../Modules/Tasks/AllocatePayments/PQASTab/components/gridComponents/pqasUtils';
import {
  handleCommaSeparatedAmount,
  removeCommaForNumberFiled,
  removeDollarForNumberFiled,
  removePercentageForNumberFiled,
  replaceCommaIntoWhiteSpace,
  replaceWhiteSpaceIntoString,
} from '../CommonUtilities/commonUtilities';
import CommonModal from '../Dialog/CommonModal';
import { dispatchTableLoader } from '../Table/store/Actions';
import { checkActionAccessByRole } from '../utilities/utilities';

const PDFExportPanel = (props) => {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const {
    isExport = true,
    addRowsView,
    addRowsTitle,
    onClickAddNdC,
    handleClickOpenDelete,
    goToClient,
    goToGroup,
    goToRebateManage,
    isPlanScreen,
    isAllocatePaymentScreen,
    uraFlag,
    viewCopyPage,
    viewCopyPageAction,
    viewPreview,
    viewPreviewAction,
    ShowStartDateOption,
    handleViewDetailsForInvoiceDetail,
    handleRedirectURLLink,
    handleViewDetailsForClaimDetail,
    claimHandleRedirectURLLink,
    handleViewDetailsForRebatePriceDetails,
    handleGoToNdcURLLink,
    fileName,
    showSearchInfo,
    showFooterForPDF,
    footerVariable,
    planByCGP,
    info,
    isScrollOn,
    showMailoutOptions = false,
    mailoutHandler,
    defaultColWidth,
    exportOnlyTotal,
    researchActions,
    handleResearchInvoiceAmount,
    handleResearchAdjustments,
    handleResearchPayments,
    navigateHandler,
    showAdditionalOptions = false,
    showGoToNDCOptions = false,
    checkAllocatePqasScreen,
    activeInvoiceNum,
    activeCheckLogNum,
    customPDFExport,
    exportToPDF,
    download,
    exportAllE,
    providerAllClaimPDFExport,
    exportAllLEFTE,
    exportAllTpPDF,
    exportAllTpPDFOne,
    exportAllToXlsx,
    exportAllToXlsx1,
    exportAllToXlsx2,
    exportAllToCSV,
    reportName,
    showExportPdfOption = true,
    skipHeaderRow,
    handleOptionForDisputedClaims,
    handleFreezeValuesPopup,
    // isEnablebyRole,
    skipAlertPopup = false,
    freezeDisabled,
  } = props;
  const [disableField, setDisableField] = useState(false);
  const [openDlg, setOpenDlg] = React.useState(false);
  const [extension, setExtension] = React.useState();
  const [dlgTxt, setDlgTxt] = React.useState();
  const [dlgErr, setDlgErr] = React.useState(false);
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const { used, unused, lcb, opmt, rebateProgramName } = useSelector(
    (state) => state?.sharedState?.UnallocatedBalanceReducer
  );

  const allTabActionsClickedGrid = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.actionsClickedGridLevel
  );
  const invoiceWIseActionsOnGrid = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.actionsClickedGridLevel[
        `${activeInvoiceNum}-${activeCheckLogNum}`
      ]
  );
  const pqasGridLevelActions = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.pqasGridLevelActions
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const exportHandler = useSelector(
    (state) => state.sharedState?.ClaimAuditReducer?.exportHandler
  );
  const PDF_PAGE_ORITENTATION = 'landscape';
  const PDF_WITH_HEADER_IMAGE = true;
  const PDF_WITH_FOOTER_PAGE_COUNT = true;
  const PDF_WITH_CELL_FORMATTING = false;
  const PDF_SELECTED_ROWS_ONLY = false;
  const PDF_WITH_COLUMNS_AS_LINKS = false;
  const PDF_HEADER_HEIGHT = 20;
  const PDF_ROW_HEIGHT = 0;
  const PDF_ODD_BKG_COLOR = '#fcfcfc';
  const PDF_EVEN_BKG_COLOR = '#fff';
  const PDF_HEADER_COLOR = '#f8f8f8';
  const PDF_INNER_BORDER_COLOR = '#dde2eb';
  const PDF_OUTER_BORDER_COLOR = '#babfc7';
  const FileName = fileName;
  const showFooter = showFooterForPDF;
  const footerVariableObj = footerVariable;
  useEffect(() => {
    if (
      props?.planByCGP &&
      props.planByCGP?.length &&
      props.planByCGP.every((val) => val.rebateProgramCd === null)
    ) {
      setDisableField(true);
    } else {
      setDisableField(false);
    }
  }, [props.planByCGP]);
  const updateLoader = (value) => dispatch(dispatchTableLoader(value));
  const submitFormHandler = (saveAsFile) => {
    // event.preventDefault();
    if (customPDFExport) {
      customPDFExport(dlgTxt);
      return;
    }

    const printParams = {
      PDF_HEADER_COLOR,
      PDF_INNER_BORDER_COLOR,
      PDF_OUTER_BORDER_COLOR,
      FileName,
      PDF_PAGE_ORITENTATION,
      PDF_WITH_HEADER_IMAGE,
      PDF_WITH_FOOTER_PAGE_COUNT,
      PDF_HEADER_HEIGHT,
      PDF_ROW_HEIGHT,
      PDF_ODD_BKG_COLOR,
      PDF_EVEN_BKG_COLOR,
      PDF_WITH_CELL_FORMATTING,
      PDF_WITH_COLUMNS_AS_LINKS,
      PDF_SELECTED_ROWS_ONLY,
      showFooter,
      footerVariableObj,
      skipHeaderRow,
    };

    printDoc(
      updateLoader,
      saveAsFile,
      printParams,
      props.gridApi,
      props.columnApi,
      props.fileName,
      UserDefaultValues,
      props.hideColumnsInPdf,
      showFooter,
      footerVariableObj,
      info || {
        firstInfo: '',
        secondInfo: '',
        thirdInfo: '',
        fourthInfo: '',
      },
      isScrollOn,
      defaultColWidth,
      exportOnlyTotal,
      reportName,
      logInUser,
      skipHeaderRow
    );
  };

  const handleActionsForAPI = (value) => {
    const tempObj = allTabActionsClickedGrid;
    tempObj[`${activeInvoiceNum}-${activeCheckLogNum}`] = {
      addNDC: value === 'addNDC',
      payRem: value === 'payRem',
      payRemUsingCMS: value === 'payRemUsingCMS',
      undoGroupPay: value === 'undoGroupPay',
      markIntSet: value === 'markIntSet',
      jumpToNDC: value === 'jumpToNDC',
    };
    dispatch(dispatchGridLevelActions(tempObj));
  };

  // call for tablegrid actions on PQAS Allocate payments
  const callActionsOnPqas = (value) => {
    const newData = pqasPageChanges(pqasGridLevelActions, value);
    dispatch(dispatchPQASGridLevelActions({ ...newData }));
  };

  const onBtnExport = (filename) => {
    if (props.ExportCsv) {
      props.ExportCsv(dlgTxt || filename);
    } else {
      props.childRef.current.ExportCsv(dlgTxt || filename);
    }
    updateLoader(false);
  };
  const customExportExcelConverter = (jsonData, columnDefs) => {
    let numberOfFiledList = [];
    let numberOFChildren = 0;
    const tempColumnDef =
      columnDefs?.filter((x) => x.children)?.length > 0
        ? columnDefs?.map((item) => {
            if (item.children) {
              item.isAmount = true;
            }
            return item;
          })
        : columnDefs;
    numberOfFiledList = tempColumnDef?.filter((x) => {
      return (
        x?.cellStyle?.textAlign === 'right' ||
        x?.alignRight ||
        x?.exportOption?.printWithCurrency ||
        x?.isAmount ||
        x?.isTextColorRed ||
        x?.printPrefixValue?.includes('$') ||
        x?.exportZeroesOne ||
        x?.exportZeroesTwo ||
        x?.exportZeroesThree ||
        x?.exportZeroesFour ||
        x?.exportZeroSix
      );
    });
    if (tempColumnDef?.filter((x) => x.children)?.length > 0) {
      tempColumnDef.forEach((prop) => {
        if (prop.children?.length > 0) {
          numberOFChildren += prop.children?.length;
          prop.children.forEach((x) => {
            if (
              x?.cellStyle?.textAlign === 'right' ||
              x?.alignRight ||
              x?.exportOption?.printWithCurrency ||
              x?.isAmount ||
              x?.isTextColorRed ||
              x?.printPrefixValue?.includes('$') ||
              x?.exportZeroesOne ||
              x?.exportZeroesTwo ||
              x?.exportZeroesThree ||
              x?.exportZeroesFour ||
              x?.exportZeroSix
            ) {
              numberOfFiledList.push(x);
            }
          });
        }
      });
    }
    if (numberOFChildren > 0) {
      for (let i = 0; i < numberOFChildren; i += 1) {
        numberOfFiledList.push({
          headerName: `field${i + 1}`,
        });
      }
      numberOfFiledList = [
        ...new Map(
          numberOfFiledList?.map((item) => [item?.headerName, item])
        ).values(),
      ];
    }
    return XLSX.utils.json_to_sheet(
      jsonData?.map((item) => {
        if (numberOfFiledList?.length > 0) {
          for (let i = 0; i < numberOfFiledList?.length; i += 1) {
            const headerName = replaceWhiteSpaceIntoString(
              numberOfFiledList[i]?.headerName
            );
            if (item[headerName]) {
              let value = removeCommaForNumberFiled(
                removeDollarForNumberFiled(item[headerName])
              );
              if (value?.includes('~=~')) {
                value = value?.split('~=~')[0];
              }
              if (!isNaN(Number(value))) {
                if (value.includes('.')) {
                  item[headerName] = value; 
                } else {
                  item[headerName] = Number(value);
                }
              }  
            }
          }
        }
        return item;
      })
    );
  };
  const onBtnExportAllExcel = async (type) => {
    const { jsonData = [], boldRows } = await exportAllToXlsx();
    const fileType =
      type === 'csv'
        ? 'text/csv;encoding:utf-8'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = type === 'csv' ? '.csv' : '.xlsx';
    const columnDefs = props?.columnApi?.columnModel?.columnDefs;
    const ws = customExportExcelConverter(jsonData, columnDefs);
    Object.keys(ws).map((key) => {
      let amountStr = '';

      // If there's a dollar sign, remove it before processing
      if (ws[key].v?.toString()?.includes('$')) {
        amountStr = removeCommaForNumberFiled(
          ws[key].v?.toString()?.replace('-', '').trim()
        );
      }

      const isIncludeDollar = !isNaN(
        parseFloat(removeDollarForNumberFiled(amountStr)?.trim())
      );
      const isIncludePercentile =
        !ws[key].v?.toString()?.includes('$') &&
        ws[key].v?.toString().split('%')[0]?.trim() !== '' &&
        ws[key].v?.toString()?.includes('%');

      if (
        ws[key]?.t === 's' &&
        (ws[key].v || ws[key].v === 0) &&
        (isIncludeDollar
          ? !isNaN(removeDollarForNumberFiled(ws[key].v)?.trim())
          : !isNaN(ws[key].v))
      ) {
        const dollarAmt = removeCommaForNumberFiled(
          removeDollarForNumberFiled(ws[key].v)?.trim()
        );
        const isNegativeVal = isIncludeDollar
          ? parseFloat(dollarAmt?.trim()) < 0
          : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);

        // Adjust formatting for negative numbers (replace parentheses with minus sign)
        if (isNegativeVal && isIncludeDollar) {
          let value = ws[key].v;
          if (isIncludeDollar) {
            value = removeDollarForNumberFiled(ws[key].v)?.trim();
          }
          if (!isNaN(parseFloat(replaceCommaIntoWhiteSpace(value)))) {
            value = `- ${Math.abs(replaceCommaIntoWhiteSpace(value)).toFixed(
              2
            )}`; // Replace $ and parentheses with '-'
          }
          if (value?.toString()?.includes('$')) {
            const formattedValue = removeDollarForNumberFiled(value)?.trim();
            value = handleCommaSeparatedAmount(
              replaceCommaIntoWhiteSpace(formattedValue)
            );
          }
          ws[key] = {
            ...ws[key],
            s: {
              font: { bold: true, color: { rgb: 'FF0000' } },
              alignment: { horizontal: 'right' }, // Align negative value to the right
            },
            v: value === '' ? '' : `${value}`, // Remove parentheses and add minus sign for negative value
          };
        }

        // Ensure no dollar signs for positive values
        if (isIncludeDollar && !isNegativeVal) {
          ws[key] = {
            ...ws[key],
            s: {
              ...ws[key].s,
              alignment: { horizontal: 'right' }, // Align positive value to the right
            },
            v: `${removeDollarForNumberFiled(ws[key].v).trim()}`, // Remove dollar sign for positive values
          };
        }

        // Adjust percentage formatting
        if (
          isIncludePercentile &&
          !isNaN(removePercentageForNumberFiled(ws[key].v)?.trim())
        ) {
          const percentageVal = removeCommaForNumberFiled(
            removePercentageForNumberFiled(ws[key].v)?.trim()
          );
          const isNegativeVal = isIncludePercentile
            ? parseFloat(percentageVal?.trim()) < 0
            : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);
          if (isNegativeVal || parseFloat(percentageVal) < 0) {
            ws[key] = {
              ...ws[key],
              s: {
                font: { bold: true, color: { rgb: 'FF0000' } },
                alignment: { horizontal: 'right' }, // Align percentage to the right
              },
              v: `-${Math.abs(percentageVal)} %`, // Replace parentheses with minus for negative percentages
            };
          } else {
            ws[key] = {
              ...ws[key],
              s: {
                alignment: { horizontal: 'right' }, // Align percentage to the right
              },
              v: `${percentageVal} %`,
            };
          }
        }
        // Bold rows logic (if any)
        if (boldRows.indexOf(parseInt(key.substring(1))) !== -1) {
          ws[key] = {
            ...ws[key],
            s: {
              ...ws[key].s,
              font: { bold: true },
              alignment: {
                horizontal: isNaN(
                  Number(
                    ws[key]?.v
                      ?.replace(/\$/g, '')
                      ?.replace(/,/g, '')
                      ?.replace(/\%/g, '')
                  )
                )
                  ? 'left'
                  : 'right',
              },
            },
          };
        }
        const splitOnAdditionalString = ws[key].v?.split('~=~');
        if (
          !isIncludeDollar &&
          !isIncludePercentile &&
          splitOnAdditionalString?.length === 2
        ) {
          ws[key] = {
            ...ws[key],
            s: {
              font:
                parseFloat(
                  removeCommaForNumberFiled(splitOnAdditionalString[0]?.trim())
                ) < 0
                  ? { bold: true, color: { rgb: 'FF0000' } }
                  : {},
              alignment: { horizontal: 'right' }, // Align to the right for all values
            },
            v:
              parseFloat(
                removeCommaForNumberFiled(splitOnAdditionalString[0]?.trim())
              ) < 0
                ? `- ${splitOnAdditionalString[0]
                    ?.toString()
                    ?.replace('-', '')
                    .trim()}` // Replace parentheses with minus for negative values
                : splitOnAdditionalString[0],
          };
        }
      }
    });
    const makeSafeSheetName = (name) => {
      if (!name) return 'Sheet1';
      const cleaned = name.replace(/[:\\\/\?\*\[\]]/g, '');
      return cleaned.substring(0, 31) || 'Sheet1';
    };
    const sheetName = makeSafeSheetName(`${dlgTxt}_${FileName}`);
    const wb = {
      Sheets: { [sheetName]: ws },
      SheetNames: [sheetName],
    };

    const excelBuffer = XLSX.write(wb, { bookType: type, type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `${dlgTxt || FileName}${fileExtension}`);
    updateLoader(false);
  };
  const onBtnExportAllExcelDownloadClaims = async (type) => {
    const { jsonData = [], boldRows } = await download();
    const fileType =
      type === 'csv'
        ? 'text/csv;encoding:utf-8'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = type === 'csv' ? '.csv' : '.xlsx';
    const columnDefs = props?.columnApi?.columnModel?.columnDefs;
    console.log(jsonData, 'jsonDatassclaims');
    console.log(columnDefs, 'columnDefsclaimsss');
    const ws = customExportExcelConverter(jsonData, columnDefs);
    Object.keys(ws).map((key) => {
      let amountStr = '';

      if (ws[key].v?.toString()?.includes('$')) {
        amountStr = removeCommaForNumberFiled(
          ws[key].v?.toString()?.replace('-', '').trim()
        );
      }

      const isIncludeDollar = !isNaN(
        parseFloat(removeDollarForNumberFiled(amountStr)?.trim())
      );
      const isIncludePercentile =
        !ws[key].v?.toString()?.includes('$') &&
        ws[key].v?.toString().split('%')[0]?.trim() !== '' &&
        ws[key].v?.toString()?.includes('%');

      if (
        ws[key]?.t === 's' &&
        (ws[key].v || ws[key].v === 0) &&
        (isIncludeDollar
          ? !isNaN(removeDollarForNumberFiled(ws[key].v)?.trim())
          : !isNaN(ws[key].v))
      ) {
        const dollarAmt = removeCommaForNumberFiled(
          removeDollarForNumberFiled(ws[key].v)?.trim()
        );
        const isNegativeVal = isIncludeDollar
          ? parseFloat(dollarAmt?.trim()) < 0
          : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);

        // Adjust formatting for negative numbers (replace parentheses with minus sign)
        if (isNegativeVal && isIncludeDollar) {
          let value = ws[key].v;
          if (isIncludeDollar) {
            value = removeDollarForNumberFiled(ws[key].v)?.trim();
          }
          if (!isNaN(parseFloat(replaceCommaIntoWhiteSpace(value)))) {
            value = `- ${Math.abs(replaceCommaIntoWhiteSpace(value)).toFixed(
              2
            )}`; // Replace $ and parentheses with '-'
          }
          if (value?.toString()?.includes('$')) {
            const formattedValue = removeDollarForNumberFiled(value)?.trim();
            value = handleCommaSeparatedAmount(
              replaceCommaIntoWhiteSpace(formattedValue)
            );
          }
          ws[key] = {
            ...ws[key],
            s: {
              font: { bold: true, color: { rgb: 'FF0000' } },
              alignment: { horizontal: 'right' }, // Align negative value to the right
            },
            v: value === '' ? '' : `${value}`, // Remove parentheses and add minus sign for negative value
          };
        }

        // Ensure no dollar signs for positive values
        if (isIncludeDollar && !isNegativeVal) {
          ws[key] = {
            ...ws[key],
            s: {
              ...ws[key].s,
              alignment: { horizontal: 'right' }, // Align positive value to the right
            },
            v: `${removeDollarForNumberFiled(ws[key].v).trim()}`, // Remove dollar sign for positive values
          };
        }

        // Adjust percentage formatting
        if (
          isIncludePercentile &&
          !isNaN(removePercentageForNumberFiled(ws[key].v)?.trim())
        ) {
          const percentageVal = removeCommaForNumberFiled(
            removePercentageForNumberFiled(ws[key].v)?.trim()
          );
          const isNegativeVal = isIncludePercentile
            ? parseFloat(percentageVal?.trim()) < 0
            : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);
          if (isNegativeVal || parseFloat(percentageVal) < 0) {
            ws[key] = {
              ...ws[key],
              s: {
                font: { bold: true, color: { rgb: 'FF0000' } },
                alignment: { horizontal: 'right' }, // Align percentage to the right
              },
              v: `-${Math.abs(percentageVal)} %`, // Replace parentheses with minus for negative percentages
            };
          } else {
            ws[key] = {
              ...ws[key],
              s: {
                alignment: { horizontal: 'right' }, // Align percentage to the right
              },
              v: `${percentageVal} %`,
            };
          }
        }
        // Bold rows logic (if any)
        if (boldRows.indexOf(parseInt(key.substring(1))) !== -1) {
          ws[key] = {
            ...ws[key],
            s: {
              ...ws[key].s,
              font: { bold: true },
              alignment: {
                horizontal: isNaN(
                  Number(
                    ws[key]?.v
                      ?.replace(/\$/g, '')
                      ?.replace(/,/g, '')
                      ?.replace(/\%/g, '')
                  )
                )
                  ? 'left'
                  : 'right',
              },
            },
          };
        }
        const splitOnAdditionalString = ws[key].v?.split('~=~');
        if (
          !isIncludeDollar &&
          !isIncludePercentile &&
          splitOnAdditionalString?.length === 2
        ) {
          ws[key] = {
            ...ws[key],
            s: {
              font:
                parseFloat(
                  removeCommaForNumberFiled(splitOnAdditionalString[0]?.trim())
                ) < 0
                  ? { bold: true, color: { rgb: 'FF0000' } }
                  : {},
              alignment: { horizontal: 'right' }, // Align to the right for all values
            },
            v:
              parseFloat(
                removeCommaForNumberFiled(splitOnAdditionalString[0]?.trim())
              ) < 0
                ? `- ${splitOnAdditionalString[0]
                    ?.toString()
                    ?.replace('-', '')
                    .trim()}` // Replace parentheses with minus for negative values
                : splitOnAdditionalString[0],
          };
        }
      }
    });
    const makeSafeSheetName = (name) => {
      if (!name) return 'Sheet1';

      const cleaned = name.replace(/[:\\\/\?\*\[\]]/g, '');
      return cleaned.substring(0, 31) || 'Sheet1';
    };

    const sheetName = makeSafeSheetName(`${dlgTxt}_${FileName}`);

    const wb = {
      Sheets: { [sheetName]: ws },
      SheetNames: [sheetName],
    };
    const excelBuffer = XLSX.write(wb, { bookType: type, type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `${dlgTxt || FileName}${fileExtension}`);
    updateLoader(false);
  };

  const onBtnExportExcel = () => {
    const csvData = props.ExportExcel
      ? props.ExportExcel()
      : props.childRef.current.ExportExcel();
    const columnDefs = props?.columnApi?.columnModel?.columnDefs;
    // Preprocess CSV: if the CSV uses two header rows (grouped headers),
    const splitCsvLine = (line) => {
      const cells = [];
      let cur = '';
      let inQuotes = false;
      for (let i = 0; i < line.length; i += 1) {
        const ch = line[i];
        if (ch === '"') {
          if (inQuotes && line[i + 1] === '"') {
            cur += '"';
            i += 1;
          } else {
            inQuotes = !inQuotes;
          }
          continue;
        }
        if (ch === ',' && !inQuotes) {
          cells.push(cur);
          cur = '';
          continue;
        }
        cur += ch;
      }
      cells.push(cur);
      return cells;
    };

    const stripQuotes = (s) => {
      if (s == null) return '';
      let t = s.toString().trim();
      if (t.startsWith('"') && t.endsWith('"'))
        t = t.substring(1, t.length - 1);
      t = t
        .replace(/\"/g, '"')
        .replace(/^'+|'+$/g, '')
        .trim();
      return t.replace(/^\(+|\)+$/g, '').trim();
    };

    const detectMultiHeader = (csv) => {
      try {
        const lines = csv.split(/\r?\n/);
        if (lines.length < 2) return { isMultiHeader: false };
        const first = splitCsvLine(lines[0]).map(stripQuotes);
        const second = splitCsvLine(lines[1]).map(stripQuotes);
        const isHeaderLike = (arr) => arr.some((c) => c && isNaN(Number(c)));
        if (
          first.length === second.length &&
          isHeaderLike(first) &&
          isHeaderLike(second)
        ) {
          return {
            isMultiHeader: true,
            header1: first,
            header2: second,
            dataLines: lines.slice(2),
          };
        }
        return { isMultiHeader: false };
      } catch (e) {
        return { isMultiHeader: false };
      }
    };

    const detection = detectMultiHeader(csvData);
    let detectionChildreFlag = false;
    columnDefs.forEach((col) => {
      if (Array.isArray(col?.children) && col?.children?.length > 0) {
        detectionChildreFlag = true;
      }
    });

    if (detection.isMultiHeader && detectionChildreFlag) {
      const aoa = [];
      aoa.push(detection.header1.map((h) => (h == null ? '' : h)));
      aoa.push(detection.header2.map((h) => (h == null ? '' : h)));
      detection.dataLines.forEach((ln) => {
        if (!ln || ln.trim() === '') return;
        const row = splitCsvLine(ln).map((c) => {
          const v = stripQuotes(c);
          return v;
        });
        aoa.push(row);
      });

      let ws = XLSX.utils.aoa_to_sheet(aoa);

      const columnDefs = props?.columnApi?.columnModel?.columnDefs;
      // remove NDC
      Object.keys(ws).forEach((key) => {
        if (ws[key].v?.toString()?.includes('//')) {
          const pattern =
            /^\d{5}-\d{4}-\d{2}\/\/[0-9a-fA-F]{8}(?:-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/;
          if (pattern?.test(ws[key]?.v)) {
            ws[key].v = ws[key].v ? ws[key].v.toString().split('//')[0] : '0';
          }
        }
      });

      Object.keys(ws).map((key) => {
        let amountStr = '';
        if (ws[key].v?.toString()?.includes('$')) {
          amountStr = removeCommaForNumberFiled(
            ws[key].v?.toString()?.replace('-', '').trim()
          );
        }

        const isIncludeDollar = !isNaN(
          parseFloat(removeDollarForNumberFiled(amountStr)?.trim())
        );
        const isIncludePercentile =
          !ws[key].v?.toString()?.includes('$') &&
          ws[key].v?.toString()?.split('%')[0]?.trim() !== '' &&
          ws[key].v?.toString()?.includes('%');

        if (
          ws[key]?.t === 's' &&
          (ws[key].v || ws[key].v === 0) &&
          (isIncludeDollar
            ? !isNaN(removeDollarForNumberFiled(ws[key].v)?.trim())
            : !isNaN(ws[key].v))
        ) {
          const dollarAmt = removeCommaForNumberFiled(
            removeDollarForNumberFiled(ws[key].v)?.trim()
          );
          const isNegativeVal = isIncludeDollar
            ? parseFloat(dollarAmt?.trim()) < 0
            : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);

          if (isNegativeVal && isIncludeDollar) {
            let value = ws[key].v;
            if (isIncludeDollar) {
              value = removeDollarForNumberFiled(ws[key].v)?.trim();
            }
            if (!isNaN(parseFloat(replaceCommaIntoWhiteSpace(value)))) {
              value = `- ${Math.abs(replaceCommaIntoWhiteSpace(value)).toFixed(
                2
              )}`;
            }
            if (value?.toString()?.includes('$')) {
              const formattedValue = removeDollarForNumberFiled(value)?.trim();

              value = handleCommaSeparatedAmount(
                replaceCommaIntoWhiteSpace(formattedValue)
              );
            }
            ws[key] = {
              ...ws[key],
              s: {
                font: { bold: true, color: { rgb: 'FF0000' } },
                alignment: { horizontal: 'right' },
              },
              v: value === '' ? '' : `${value}`,
            };
          }

          if (isIncludeDollar && !isNegativeVal) {
            ws[key] = {
              ...ws[key],
              s: {
                ...ws[key].s,
                alignment: { horizontal: 'right' },
              },
              v: `${removeDollarForNumberFiled(ws[key].v).trim()}`,
            };
          }

          if (
            isIncludePercentile &&
            !isNaN(removePercentageForNumberFiled(ws[key].v)?.trim())
          ) {
            const percentageVal = removeCommaForNumberFiled(
              removePercentageForNumberFiled(ws[key].v)?.trim()
            );
            const isNegativeVal = isIncludePercentile
              ? parseFloat(percentageVal?.trim()) < 0
              : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);
            if (isNegativeVal || parseFloat(percentageVal) < 0) {
              ws[key] = {
                ...ws[key],
                s: {
                  font: { bold: true, color: { rgb: 'FF0000' } },
                  alignment: { horizontal: 'right' },
                },
                v: `-${Math.abs(percentageVal)} %`,
              };
            } else {
              ws[key] = {
                ...ws[key],
                s: {
                  alignment: { horizontal: 'right' },
                },
                v: `${percentageVal} %`,
              };
            }
          }

          const splitOnAdditionalString = ws[key].v?.split('~=~');
          if (
            !isIncludeDollar &&
            !isIncludePercentile &&
            splitOnAdditionalString?.length === 2
          ) {
            ws[key] = {
              ...ws[key],
              s: {
                font:
                  parseFloat(
                    removeCommaForNumberFiled(
                      splitOnAdditionalString[0]?.trim()
                    )
                  ) < 0
                    ? { bold: true, color: { rgb: 'FF0000' } }
                    : {},
                alignment: { horizontal: 'right' }, // Align to the right for all values
              },
              v:
                parseFloat(
                  removeCommaForNumberFiled(splitOnAdditionalString[0]?.trim())
                ) < 0
                  ? `- ${splitOnAdditionalString[0]
                      ?.toString()
                      ?.replace('-', '')
                      .trim()}` // Replace parentheses with minus for negative values
                  : splitOnAdditionalString[0],
            };
          }
        }
      });
      const safeSheetName = (name) => {
        if (!name) return 'Sheet1';
        let cleaned = name.replace(/[\\/?*\[\]:]/g, '');
        return cleaned.substring(0, 31);
      };
      const sheetName = safeSheetName(`${dlgTxt || FileName}`);

      const wb = {
        Sheets: { [`${sheetName}`]: ws },
        SheetNames: [`${sheetName}`],
      };

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, `${dlgTxt || FileName}${fileExtension}`);
      updateLoader(false);
    } else {
      converCsvtoJSON()
        .fromString(csvData)
        .then((jsonData) => {
          const fileType =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          const fileExtension = '.xlsx';

          // Filter columnDefs for visible columns only
          // const displayedColumns = props.columnApi.getAllDisplayedColumns(); // All visible columns
          // const displayedColIds = displayedColumns.map(col => col.colId || col.field);
          // const filteredColumnDefs = props?.columnApi?.columnModel?.columnDefs
          //   ?.filter(col => displayedColIds.includes(col.colId || col.field));
          // // Map field -> headerName for only displayed columns
          // const fieldToHeader = {};
          // filteredColumnDefs.forEach(col => {
          //   fieldToHeader[col.field] = col.headerName;
          // });

          // // filter jsonData
          // const filteredJsonData = jsonData.map(row => {
          //   const filteredRow = {};
          //   Object.entries(fieldToHeader).forEach(([field, headerName]) => {
          //     if (row[headerName] !== undefined) {
          //       filteredRow[headerName] = row[headerName];
          //     }
          //   });
          //   return filteredRow;
          // });

          // // Create ordered columnDefs based on displayedColumns
          // const orderedColumnDefs = displayedColumns.map(displayedCol => {
          //   return filteredColumnDefs.find(colDef => (colDef.colId || colDef.field) === (displayedCol.colId || displayedCol.field));
          // }).filter(Boolean); // Remove any undefined entries

          // const ws = customExportExcelConverter(filteredJsonData, orderedColumnDefs);
          const columnDefs = props?.columnApi?.columnModel?.columnDefs;
          const ws = customExportExcelConverter(jsonData, columnDefs);
          //remove NDC
          Object.keys(ws).forEach((key) => {
            if (ws[key].v?.toString()?.includes('//')) {
              const pattern =
                /^\d{5}-\d{4}-\d{2}\/\/[0-9a-fA-F]{8}(?:-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/;
              if (pattern?.test(ws[key]?.v)) {
                ws[key].v = ws[key].v
                  ? ws[key].v.toString().split('//')[0]
                  : '0';
              }
            }
          });

          // Loop through all the cells in the sheet
          Object.keys(ws).forEach((key) => {
            if (ws[key].v?.toString()?.includes('field')) {
              ws[key].v = ' ';
            }
          });

          Object.keys(ws).map((key) => {
            let amountStr = '';
            // If there's a dollar sign, remove it before processing
            if (ws[key].v?.toString()?.includes('$')) {
              amountStr = removeCommaForNumberFiled(
                ws[key].v?.toString()?.replace('-', '').trim()
              );
            }

            const isIncludeDollar = !isNaN(
              parseFloat(removeDollarForNumberFiled(amountStr)?.trim())
            );
            const isIncludePercentile =
              !ws[key].v?.toString()?.includes('$') &&
              ws[key].v?.toString().split('%')[0]?.trim() !== '' &&
              ws[key].v?.toString()?.includes('%');

            if (
              ws[key]?.t === 's' &&
              (ws[key].v || ws[key].v === 0) &&
              (isIncludeDollar
                ? !isNaN(removeDollarForNumberFiled(ws[key].v)?.trim())
                : !isNaN(ws[key].v))
            ) {
              const dollarAmt = removeCommaForNumberFiled(
                removeDollarForNumberFiled(ws[key].v)?.trim()
              );
              const isNegativeVal = isIncludeDollar
                ? parseFloat(dollarAmt?.trim()) < 0
                : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);

              // Adjust formatting for negative numbers (replace parentheses with minus sign)
              if (isNegativeVal && isIncludeDollar) {
                let value = ws[key].v;
                if (isIncludeDollar) {
                  value = removeDollarForNumberFiled(ws[key].v)?.trim();
                }
                if (!isNaN(parseFloat(replaceCommaIntoWhiteSpace(value)))) {
                  value = `- ${Math.abs(
                    replaceCommaIntoWhiteSpace(value)
                  ).toFixed(2)}`; // Replace $ and parentheses with '-'
                }
                if (value?.toString()?.includes('$')) {
                  const formattedValue =
                    removeDollarForNumberFiled(value)?.trim();

                  value = handleCommaSeparatedAmount(
                    replaceCommaIntoWhiteSpace(formattedValue)
                  );
                }
                ws[key] = {
                  ...ws[key],
                  s: {
                    font: { bold: true, color: { rgb: 'FF0000' } },
                    alignment: { horizontal: 'right' }, // Align negative value to the right
                  },
                  v: value === '' ? '' : `${value}`, // Remove parentheses and add minus sign for negative value
                };
              }

              // Ensure no dollar signs for positive values
              if (isIncludeDollar && !isNegativeVal) {
                ws[key] = {
                  ...ws[key],
                  s: {
                    ...ws[key].s,
                    alignment: { horizontal: 'right' }, // Align positive value to the right
                  },
                  v: `${removeDollarForNumberFiled(ws[key].v).trim()}`, // Remove dollar sign for positive values
                };
              }

              // Adjust percentage formatting
              if (
                isIncludePercentile &&
                !isNaN(removePercentageForNumberFiled(ws[key].v)?.trim())
              ) {
                const percentageVal = removeCommaForNumberFiled(
                  removePercentageForNumberFiled(ws[key].v)?.trim()
                );
                const isNegativeVal = isIncludePercentile
                  ? parseFloat(percentageVal?.trim()) < 0
                  : !isNaN(ws[key].v) && !(parseFloat(ws[key].v) >= 0);
                if (isNegativeVal || parseFloat(percentageVal) < 0) {
                  ws[key] = {
                    ...ws[key],
                    s: {
                      font: { bold: true, color: { rgb: 'FF0000' } },
                      alignment: { horizontal: 'right' }, // Align percentage to the right
                    },
                    v: `-${Math.abs(percentageVal)} %`, // Replace parentheses with minus for negative percentages
                  };
                } else {
                  ws[key] = {
                    ...ws[key],
                    s: {
                      alignment: { horizontal: 'right' }, // Align percentage to the right
                    },
                    v: `${percentageVal} %`,
                  };
                }
              }

              const splitOnAdditionalString = ws[key].v?.split('~=~');
              if (
                !isIncludeDollar &&
                !isIncludePercentile &&
                splitOnAdditionalString?.length === 2
              ) {
                ws[key] = {
                  ...ws[key],
                  s: {
                    font:
                      parseFloat(
                        removeCommaForNumberFiled(
                          splitOnAdditionalString[0]?.trim()
                        )
                      ) < 0
                        ? { bold: true, color: { rgb: 'FF0000' } }
                        : {},
                    alignment: { horizontal: 'right' }, // Align to the right for all values
                  },
                  v:
                    parseFloat(
                      removeCommaForNumberFiled(
                        splitOnAdditionalString[0]?.trim()
                      )
                    ) < 0
                      ? `- ${splitOnAdditionalString[0]
                          ?.toString()
                          ?.replace('-', '')
                          .trim()}` // Replace parentheses with minus for negative values
                      : splitOnAdditionalString[0],
                };
              }
            }
          });
          const safeSheetName = (name) => {
            if (!name) return 'Sheet1';
            let cleaned = name.replace(/[\\/?*\[\]:]/g, '');
            return cleaned.substring(0, 31);
          };
          const sheetName = safeSheetName(`${dlgTxt || FileName}`);

          const wb = {
            Sheets: { [`${sheetName}`]: ws },
            SheetNames: [`${sheetName}`],
          };

          const excelBuffer = XLSX.write(wb, {
            bookType: 'xlsx',
            type: 'array',
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, `${dlgTxt || FileName}${fileExtension}`);
        });
      updateLoader(false);
    }
  };
  const assignStartDates = () => {
    dispatch(updateActionBit(true));
  };

  useEffect(() => {
    if (kcRoles?.userPrivileges?.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  return (
    <>
      <Dropdown className="icon-dropdown-container">
        <Dropdown.Toggle className="icon-dropdown" aria-label="Actions Button">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
          >
            <img
              alt="Export Button"
              style={{ marginRight: '-10px' }}
              src={ExportIcon}
            />
          </OverlayTrigger>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {addRowsView && (
            <Dropdown.Item onClick={onClickAddNdC} 
            disabled={addRowsTitle?.startsWith('View')
                ? false
                : !addRowsTitle?.startsWith('Print') && !isEnablebyRole
            }>
              {addRowsTitle}
            </Dropdown.Item>
          )}
          {viewCopyPage && (
            <Dropdown.Item
              onClick={viewCopyPageAction}
              disabled={
                !viewCopyPage?.startsWith('Show Main') && !isEnablebyRole
              }
            >
              {viewCopyPage}
            </Dropdown.Item>
          )}
          {viewPreview && (
            <Dropdown.Item onClick={viewPreviewAction}>
              {viewPreview}
            </Dropdown.Item>
          )}
          {typeof handleFreezeValuesPopup === 'function' && (
            <Dropdown.Item
              role="button"
              onClick={() => {
                handleFreezeValuesPopup();
              }}
              disabled={freezeDisabled}
            >
              {' '}
              Freeze Values
            </Dropdown.Item>
          )}
          {typeof handleOptionForDisputedClaims === 'function' && (
            <>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleOptionForDisputedClaims('selectSample');
                }}
              >
                {' '}
                Select Sample
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleOptionForDisputedClaims('clearSelectedItem');
                }}
              >
                {' '}
                Clear Selected Items
              </Dropdown.Item>
            </>
          )}
          {showGoToNDCOptions && (
            <Dropdown.Item onClick={() => navigateHandler('NDC')}>
              Go to NDC
            </Dropdown.Item>
          )}
          {researchActions && (
            <>
              <Dropdown.Item onClick={() => handleResearchInvoiceAmount()}>
                Research Invoice Amount
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleResearchAdjustments()}>
                Research Adjustments
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleResearchPayments()}>
                Research Payments
              </Dropdown.Item>
            </>
          )}
          {isAllocatePaymentScreen && (
            <>
              <Dropdown.Item
                onClick={() => {
                  handleActionsForAPI('addNDC');
                }}
                disabled={!isEnablebyRole}
              >
                ADD NDC
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  handleActionsForAPI('payRem');
                }}
                disabled={!isEnablebyRole}
              >
                Pay remaining items
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  handleActionsForAPI('payRemUsingCMS');
                }}
                disabled={!isEnablebyRole}
              >
                {`Pay remaining items using ${uraFlag} URA`}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  handleActionsForAPI('undoGroupPay');
                }}
                disabled={!isEnablebyRole}
              >
                Undo Group Pay Action
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  handleActionsForAPI('markIntSet');
                }}
                disabled={!isEnablebyRole}
              >
                Mark Int settled for all
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  handleActionsForAPI('jumpToNDC');
                }}
                //disabled={!isEnablebyRole}
              >
                Jump to NDC
              </Dropdown.Item>
            </>
          )}
          {checkAllocatePqasScreen && (
            <>
              <Dropdown.Item
                onClick={() => {
                  callActionsOnPqas({ addNDC: true });
                }}
                disabled={!isEnablebyRole}
              >
                Add NDC
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  callActionsOnPqas({ markInt: true });
                }}
                disabled={!isEnablebyRole}
              >
                Mark Int settled for all
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  callActionsOnPqas({ jumpNDC: true });
                }}
                //disabled={!isEnablebyRole}
              >
                Jump to NDC
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  callActionsOnPqas({ updateCurrentURA: true });
                }}
                disabled={!isEnablebyRole}
              >
                Update current URA column
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  callActionsOnPqas({ prevNextRecord: true, prevNextVal: 1 });
                }}
                //disabled={!isEnablebyRole}
              >
                Next Record
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  callActionsOnPqas({ prevNextRecord: true, prevNextVal: 0 });
                }}
                //disabled={!isEnablebyRole}
              >
                Previous Record
              </Dropdown.Item>
            </>
          )}
          {isExport && (
            <>
              {exportAllTpPDF && (
                <Dropdown.Item
                  onClick={() => {
                    if (skipAlertPopup) {
                      customPDFExport();
                    } else {
                      setOpenDlg(true);
                      setExtension('pdfall');
                    }
                  }}
                >
                  Export All to PDF
                </Dropdown.Item>
              )}
              {exportAllTpPDFOne && (
                <Dropdown.Item
                  onClick={() => {
                    if (skipAlertPopup) {
                      customPDFExport();
                    } else {
                      setOpenDlg(true);
                      setExtension('pdfall2');
                    }
                  }}
                >
                  Export All to PDF
                </Dropdown.Item>
              )}
              {showExportPdfOption && (
                <Dropdown.Item
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('pdf');
                  }}
                >
                  Export to PDF
                </Dropdown.Item>
              )}
              {exportToPDF && (
                <Dropdown.Item
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('pdfall1');
                  }}
                >
                  Export to PDF
                </Dropdown.Item>
              )}
              {exportAllToCSV && (
                <Dropdown.Item
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('csvall');
                  }}
                >
                  Export All to CSV
                </Dropdown.Item>
              )}
              <Dropdown.Item
                onClick={() => {
                  setOpenDlg(true);
                  setExtension('csv');
                }}
              >
                Export to CSV
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setOpenDlg(true);
                  setExtension('xlsx');
                }}
              >
                Export to Excel
              </Dropdown.Item>
              {exportAllToXlsx && (
                <Dropdown.Item
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('xlsxall');
                  }}
                >
                  Export All to Excel
                </Dropdown.Item>
              )}
              {exportAllToXlsx1 && (
                <Dropdown.Item
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('xlsxall1');
                  }}
                >
                  Export All to Excel
                </Dropdown.Item>
              )}
              {exportAllToXlsx2 && (
                <Dropdown.Item
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('xlsxall2');
                  }}
                >
                  Export All to Excel
                </Dropdown.Item>
              )}
              {download && (
                <Dropdown.Item
                  //disabled={!isEnablebyRole}
                  onClick={() => {
                    setOpenDlg(true);
                    setExtension('xlsxallCustom');
                  }}
                >
                  Download
                </Dropdown.Item>
              )}
            </>
          )}
          <CommonModal
            open={openDlg}
            className="dialog-420"
            viewAction
            viewHeader
            onOk={() => {
              setOpenDlg(false);
              if (
                extension === 'xlsx' ||
                extension === 'pdf' ||
                extension === 'csv'
              )
                updateLoader(true);
              setTimeout(() => {
                if (extension === 'xlsx') onBtnExportExcel();
                if (extension === 'pdf') submitFormHandler(dlgTxt);
                if (extension === 'csv') onBtnExport(dlgTxt);
              }, 50);
              if (extension === 'pdfall1') exportToPDF(dlgTxt);
              if (extension === 'pdfall') exportAllTpPDF(dlgTxt);
              if (extension === 'pdfall2') providerAllClaimPDFExport(dlgTxt);
              if (extension === 'xlsxall') onBtnExportAllExcel('xlsx');
              if (extension === 'xlsxall1') exportAllE(dlgTxt);
              if (extension === 'xlsxall2') exportAllLEFTE(dlgTxt);
              if (extension === 'xlsxallCustom')
                onBtnExportAllExcelDownloadClaims('xlsx');
              if (extension === 'csvall') onBtnExportAllExcel('csv');
              setDlgTxt('');
              setExtension('');
            }}
            okTitle="Ok"
            disableOk={!dlgTxt || dlgErr}
            onClose={() => {
              setOpenDlg(false);
              setDlgTxt('');
              setExtension('');
            }}
            closeTitle="Cancel"
            modalTitle="Save Data In File"
            autoFocus
            childrenComponent={
              <div className="form-wrapper">
                <div className="mui-custom-form">
                  <TextField
                    className="mb-3"
                    id="filename"
                    inputProps={{ id: 'filename' }}
                    label="File Name"
                    required
                    autoComplete="off"
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    data-testid="filename-input"
                    value={dlgTxt}
                    onChange={(e) => {
                      setDlgTxt(e.target.value);
                      if (e.target.value && !/^[\w\-. ]+$/.test(e.target.value))
                        setDlgErr(true);
                      else setDlgErr(false);
                    }}
                    error={dlgErr}
                    helperText={dlgErr ? 'Invalid character in file name' : ''}
                  />
                </div>
              </div>
            }
          />
          {showMailoutOptions && (
            <Dropdown.Item onClick={() => mailoutHandler()}>
              Record Recap Mailout Date
            </Dropdown.Item>
          )}
          {showAdditionalOptions && (
            <>
              <Dropdown.Item onClick={() => navigateHandler('claims')}>
                Go to Claims
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigateHandler('NDC')}>
                Go to NDC
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigateHandler('Unit conversion')}>
                Go to Maintain Unit Conversion
              </Dropdown.Item>
            </>
          )}

          {ShowStartDateOption && (
            <>
              <Dropdown.Item onClick={assignStartDates}>
                Assign Start Dates
              </Dropdown.Item>
            </>
          )}
          {handleViewDetailsForInvoiceDetail && (
            <>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleRedirectURLLink();
                }}
              >
                {' '}
                Go to Accounts Receivable NDC detail
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleViewDetailsForInvoiceDetail();
                }}
              >
                {' '}
                Go to Invoice
              </Dropdown.Item>
            </>
          )}
          {handleViewDetailsForRebatePriceDetails && (
            <>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleGoToNdcURLLink('ndc');
                }}
              >
                {' '}
                Go to NDC
              </Dropdown.Item>

              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleGoToNdcURLLink('contract');
                }}
              >
                {' '}
                Go to Contract
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleGoToNdcURLLink('manufacturer');
                }}
              >
                {' '}
                Go to Manufacturer
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleGoToNdcURLLink('rebateprogram');
                }}
              >
                {' '}
                Go to Rebate Program
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleGoToNdcURLLink('drugfamily');
                }}
              >
                {' '}
                Go to Drug Family
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  handleGoToNdcURLLink('jumptondc');
                }}
              >
                {' '}
                Jump to NDC
              </Dropdown.Item>
            </>
          )}
          {handleViewDetailsForClaimDetail && (
            <>
              <Dropdown.Item
                onClick={async () => {
                  if (exportHandler) {
                    await exportHandler();
                    setTimeout(() => {
                      if (typeof onBtnExportExcel === 'function') {
                        onBtnExportExcel();
                      }
                    }, 0);
                  }
                }}
              >
                Export All to Excel
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                onClick={() => {
                  claimHandleRedirectURLLink();
                }}
              >
                {' '}
                Go to Unit Conversion
              </Dropdown.Item>
            </>
          )}
          {isPlanScreen && (
            <>
              <Dropdown.Item
                onClick={handleClickOpenDelete}
                disabled={!isEnablebyRole}
              >
                Delete
              </Dropdown.Item>
              <Dropdown.Item onClick={goToClient}>Go to Client</Dropdown.Item>
              <Dropdown.Item onClick={goToGroup}>Go to Group</Dropdown.Item>
              <Dropdown.Item disabled={disableField} onClick={goToRebateManage}>
                Go to Rebate Program
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default PDFExportPanel;
